import React from "react";
import StarsIcon from "./stars.js";
import Link from "helpers/link";
import GoogleIcon from "images/google.png";

import { googleReviewsStore } from "store/googleReviews";

const GoogleReviewsWidget = () => {
  const { googleReviews } = googleReviewsStore();

  const { rating, user_ratings_total, url } = googleReviews;

  if (!rating) return null;

  return (
    <div className="absolute bottom-0 left-0 right-0 container w-full translate-y-1/3 z-[3] sm:relative sm:-translate-y-1/2 sm:-mb-[75px] sm:after:content-[''] sm:after:w-full sm:after:h-1/2 sm:after:absolute sm:after:bottom-0 sm:after:left-0 sm:after:bg-white sm:after:z-[2]">
      <div className="bg-white py-3 px-5 inline-block rounded-2xl shadow-googleReviewBox relative z-[3]">
        <h3 className="font-sans font-bold text-lg text-black ">
          Old Gold Racing
        </h3>
        <div className="flex items-center justify-start gap-2.5 my-1">
          <h4 className="font-sans font-medium text-lg text-[#E7711B]">
            {rating}
          </h4>
          <div className="flex items-center justify-start gap-0.5">
            <StarsIcon rating={rating} />
          </div>
        </div>
        <p className="font-sans text-sm leading-loose text-gray-500">
          Based on {user_ratings_total} reviews
        </p>
        <div className="flex items-center justify-start gap-2">
          <p className="font-sans text-sm leading-loose text-gray-500 inline">
            Powered by
          </p>
          <img src={GoogleIcon} alt="google icon" className="w-16" />
        </div>
      </div>
    </div>
  );
};

export default GoogleReviewsWidget;
